/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Webhook_UrlInputs */

const cs_automation_webhook_url = /** @type {(inputs: Automation_Webhook_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL`)
};

const en_automation_webhook_url = /** @type {(inputs: Automation_Webhook_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL`)
};

/**
* | output |
* | --- |
* | "URL" |
*
* @param {Automation_Webhook_UrlInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_webhook_url = /** @type {((inputs?: Automation_Webhook_UrlInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Webhook_UrlInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_webhook_url(inputs)
	return cs_automation_webhook_url(inputs)
});